import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import App from "./App";

import "./styles/tokens.css";
import "./styles/index.css";
import "./styles/App.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root is missing.");
}

const boot = async (): Promise<void> => {
  let Provider: React.ComponentType<{ children: React.ReactNode }> = AuthProvider;
  if (__POC_HARNESS__) {
    const harness = await import("./harness/boot");
    const mode = await harness.prepareHarness();
    if (mode === "frame-host") return;
    Provider = harness.HarnessAuthProvider;
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <Provider>
          <App />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>,
  );
};

void boot();
